import { CONTROL_TYPES } from '@/components/AppInput.vue';
import { COMPARISON_OPERATORS, OPERATORS, TEXT_MATCH_OPERATORS } from '@/components/filterBar.helpers';
import { EMPLOYEE_PAY_TYPE } from '@/utils/Employee';
import { SHIFT_SOURCE } from '@/utils/Shifts';
import { toTitleCase } from '@/utils/common';

// shifts-v2 filter columns, shared by the Shifts and Net Pay lists so the same field can't diverge between them.
// A single-entry `operators` list means no operator menu — the choice is implied (e.g. Pay Type is one-of-two).
export const shiftOperatorFilterColumns = ({ paySchedules = [], includeHours = false, includeShiftType = false }) =>
  [
    {
      // Between only: shifts-v2 scans a bounded window, so a one-sided date filter would need the
      // other bound invented behind the user's back — and a real shift outside it returns nothing.
      key: 'worked_on',
      label: 'Date',
      type: CONTROL_TYPES.DATE,
      operators: [OPERATORS.BETWEEN],
    },
    {
      key: 'full_name',
      label: 'Employee',
      type: CONTROL_TYPES.TEXT,
      operators: TEXT_MATCH_OPERATORS,
    },
    {
      key: 'employee_code',
      label: 'Employee Code',
      type: CONTROL_TYPES.TEXT,
      operators: TEXT_MATCH_OPERATORS,
    },
    {
      key: 'work_email',
      label: 'Email',
      type: CONTROL_TYPES.TEXT,
      operators: TEXT_MATCH_OPERATORS,
    },
    includeShiftType && {
      // Integration-supplied free text (e.g. TIPS), so no fixed option list.
      key: 'shift_type',
      label: 'Type',
      type: CONTROL_TYPES.TEXT,
      operators: TEXT_MATCH_OPERATORS,
    },
    {
      key: 'source',
      label: 'Source',
      type: CONTROL_TYPES.CHECKBOX,
      options: Object.values(SHIFT_SOURCE).map(value => ({ text: toTitleCase(value), value })),
      operators: [OPERATORS.IN],
    },
    {
      key: 'salary_or_hourly',
      label: 'Pay Type',
      type: CONTROL_TYPES.RADIO,
      options: Object.values(EMPLOYEE_PAY_TYPE).map(value => ({ text: toTitleCase(value), value })),
      operators: [OPERATORS.EQ],
    },
    {
      key: 'pay_schedule_id',
      label: 'Pay Schedule',
      type: CONTROL_TYPES.RADIO,
      options: paySchedules.map(payschedule => ({ text: payschedule.name, value: payschedule.pay_schedule_id })),
      operators: [OPERATORS.EQ, OPERATORS.NE],
      hidden: !paySchedules.length,
    },
    includeHours && {
      key: 'hours',
      label: 'Hours',
      type: CONTROL_TYPES.NUMBER,
      operators: COMPARISON_OPERATORS,
    },
    {
      key: 'wages',
      label: 'Earned Wages',
      type: CONTROL_TYPES.NUMBER,
      operators: COMPARISON_OPERATORS,
    },
  ].filter(Boolean);
